import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import TextField from "../fields/TextField";
import DateField from "../fields/DateField";
import SelectField from "../fields/SelectField";
import { buildOptions, sponsorOptions } from "../utils";
import { updateMentors } from "../actions";
import { intersection } from "lodash";

class GeneralFormModal extends Component {
  constructor(props) {
    super(props);
  }

  handleClose() {
    this.props.closeModal();
  }

  componentDidMount() {
    this.setState({ referrals: this.props.referrals });
  }

  formatReferralOptions() {
    const referralOptions = this.props.referrals.map((referral) => ({
      value: referral.id,
      label: `${referral.first_name || ""} ${referral.last_name || ""} ${referral.contact_org ? `(${referral.contact_org})` : ""
        }`,
    }));
    referralOptions.push({
      value: "add",
      label: "Add new referral source",
    });
    return referralOptions;
  }

  render() {
    const mentorOptions = this.props.mentors.map((mentor) => ({
      value: mentor.id,
      label: `${mentor.first_name} ${mentor.last_name}`,
    }));
    const statusOptions = buildOptions(this.props.category_options);
    const pronounOptions = buildOptions(this.props.pronoun_options);
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>General</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <TextField
              name="first_name"
              label="First Name"
              action="edit"
              col={6}
            />
            <TextField
              name="middle_name"
              label="Middle Name"
              action="edit"
              col={6}
            />
            <TextField
              name="last_name"
              label="Last Name"
              action="edit"
              col={6}
            />
            <SelectField
              name="pronoun"
              label="Pronoun"
              action="edit"
              creatable
              col={6}
              options={pronounOptions}
            />
            <TextField
              name="nickname"
              label="Nickname/Preferred name"
              action="edit"
              col={6}
            />
            <TextField
              name="email"
              label="Email"
              action="edit"
              col={6}
              textDecorator={(text) => text.trim()}
            />
            <TextField
              name="phone"
              label="Phone"
              action="edit"
              col={6}
              textDecorator={(text) => text.trim().replace("-", "")}
            />
            <DateField
              name="birthdate"
              label="Birthdate"
              action="edit"
              as="textarea"
              col={6}
            />
            <TextField
              name="mailing_address"
              label="Mailing Address"
              action="edit"
              col={6}
            />
            <SelectField
              label="Mentors"
              options={mentorOptions}
              name="mentor_ids"
              onChange={this.props.updateMentors}
              action="edit"
              col={6}
              isMulti
            />
            <SelectField
              name="category_list"
              label="Category"
              options={statusOptions}
              creatable
              action="edit"
              col={6}
              isMulti
            />
            <TextField
              name="level"
              label="Level/Phase/Tier"
              action="edit"
              col={6}
            />
            <TextField
              name="client_number"
              label="Client Number"
              action="edit"
              col={6}
            />
            {intersection(this.props.services, ["crm"]).length == 1 && (
              <SelectField
                name="referral_id"
                label="Referral Source"
                options={this.formatReferralOptions()}
                action="edit"
                loadOptions={(inputValue, callback) => {
                  this.props
                    .fetchReferrals(inputValue)
                    .then(() =>
                      callback(this.formatReferralOptions(inputValue))
                    );
                }}
                placeholder="Type to search..."
                col={6}
                onMenuOpen={() => this.props.fetchReferrals()}
              />
            )}
            <SelectField
              name="sponsor"
              label="Sponsor"
              action="edit"
              col={6}
              options={sponsorOptions}
            />
            <TextField
              name="occupation"
              label="Occupation"
              action="edit"
              col={6}
            />
            <TextField name="address" label="Address" action="edit" col={6} />
            <TextField name="city" label="City" action="edit" col={6} />
            <TextField name="state" label="State" action="edit" col={6} />
            <TextField name="zip" label="Zip" action="edit" col={6} />
            {this.props.show_ssn ? (
              <TextField
                name="ssn"
                label="Social Security Number"
                action="edit"
                col={6}
              />
            ) : (
              <div className="col-xs-12 col-lg-6">
                <div>
                  <label>Social Security Number</label>
                  <small className="d-block">
                    You do not have permission to view/edit SSN. Ask Admin for
                    access.
                  </small>
                </div>
              </div>
            )}

            <TextField
                name="criminal_arrest_history"
                label="Criminal/Arrest History"
                action="edit"
                as="textarea"
                col={6}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={() => this.props.closeModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.generalModal.show,
    mentors: state.mentors,
    organizationName: state.organization.name,
    services: state.organization.services_names,
    resident: state.resident,
    category_options: state.org_dependant_data.category_options,
    pronoun_options: state.org_dependant_data.pronoun_options,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () =>
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "general" },
      }),
    updateMentors: (options) => dispatch(updateMentors(options)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralFormModal);
